export default __webpack_public_path__ + "static/media/user.e0e19409.svg";